import { navigate } from 'gatsby';
import React from 'react';
import { homeImage2, logo } from '../assets';

const NotFoundPage = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f7f3e9',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      textAlign: 'center',
      padding: '20px',
      background: 'linear-gradient(135deg, #f7f3e9 0%, #e8dcc0 100%)'
    },
    errorCode: {
      fontSize: '120px',
      fontWeight: 'bold',
      color: '#8B4513',
      margin: '0',
      textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
      letterSpacing: '5px'
    },
    cactusImage: {
      width: '200px',
      height: '200px',
      backgroundColor: '#90EE90',
      border: '3px solid #228B22',
      borderRadius: '10px',
      margin: '20px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#228B22',
      fontSize: '16px',
      fontWeight: 'bold'
    },
    title: {
      fontSize: '32px',
      color: '#2F4F2F',
      margin: '20px 0 10px 0',
      fontWeight: '600'
    },
    subtitle: {
      fontSize: '18px',
      color: '#556B2F',
      margin: '0 0 30px 0',
      maxWidth: '500px',
      lineHeight: '1.6'
    },
    buttonContainer: {
      display: 'flex',
      gap: '15px',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: '20px 0'
    },
    button: {
      padding: '12px 24px',
      fontSize: '16px',
      fontWeight: '600',
      border: 'none',
      borderRadius: '25px',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block',
      transition: 'all 0.3s ease',
      minWidth: '140px'
    },
    primaryButton: {
      backgroundColor: '#228B22',
      color: 'white',
      boxShadow: '0 4px 15px rgba(34, 139, 34, 0.3)'
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: '#228B22',
      border: '2px solid #228B22'
    },
    suggestions: {
      marginTop: '40px',
      padding: '20px',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      borderRadius: '15px',
      maxWidth: '600px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    },
    suggestionsTitle: {
      fontSize: '20px',
      color: '#2F4F2F',
      marginBottom: '15px',
      fontWeight: '600'
    },
    suggestionsList: {
      listStyle: 'none',
      padding: '0',
      margin: '0'
    },
    suggestionItem: {
      textAlign: 'start',
      padding: '8px 0',
      borderBottom: '1px solid rgba(47, 79, 47, 0.1)',
      color: '#556B2F',
      cursor: 'pointer'
    },
    decorativeCacti: {
      position: 'absolute',
      bottom: '20px',
      left: '20px',
      right: '20px',
      display: 'flex',
      justifyContent: 'space-between',
      pointerEvents: 'none'
    },
    smallCactus: {
      width: '60px',
      height: '80px',
      backgroundColor: '#90EE90',
      border: '2px solid #228B22',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#228B22',
      fontSize: '12px',
      opacity: '0.6'
    }
  };

  const handleHomeClick = () => {
    window.location.href = '/';
  };

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.errorCode}>404</h1>

      <img src={logo}/>

      <h2 style={styles.title}>Oops! The page you are looking for does not exist anymore</h2>

      <p style={styles.subtitle}>
        The page you're looking for seems to either be deleted or has never existed.
        Don't worry though - you can find all kinds of illustrations here!
      </p>

      <div style={styles.buttonContainer}>
        <button
          className="cactus-templete_detail-order_button"
          onClick={handleHomeClick}
        >
          <p>🏠 Back to Home</p>
        </button>

        <button
          className="cactus-templete_detail-order_button"
          onClick={handleBackClick}
          style={{ border: '3px solid #2b453e', background: 'transparent' }}
        >
          <p style={{ color: '#2b453e' }}>← Go Back</p>
        </button>
      </div>

      <div style={styles.suggestions}>
        <h3 style={styles.suggestionsTitle}>🌵 What you can do:</h3>
        <ul style={styles.suggestionsList}>
          <li style={styles.suggestionItem}>Check the URL for any typos</li>
          <li style={styles.suggestionItem} onClick={() => navigate('/')}>Browse our collection of cactus moments</li>
          <li style={styles.suggestionItem} onClick={() => navigate('/')}>Search for specific content</li>
          <li style={styles.suggestionItem} onClick={() => navigate('/contactus')}>Contact us if you think this is an error</li>
        </ul>
      </div>

    </div>
  );
};

export default NotFoundPage;